export enum GlobalPermissions {
    globalConnectLinkProfileShow = 'global.connect.link.profile.show',
}